import cn from "classnames"

import { LoadingOutlined, WarningOutlined } from "@/icons"
import type { CellWithStatusIndicatorProps } from "."

import styles from "./CellWithStatusIndicator.module.scss"

export const CellWithStatusIndicator = ({
  children,
  status,
  statusTooltip,
  applyOpacity = false,
  className,
  truncate
}: CellWithStatusIndicatorProps) => {
  const showOpacity = status === "loading" && applyOpacity

  return (
    <div
      className={cn(
        styles.container,
        showOpacity && styles.opacity,
        truncate && styles.containerTruncate,
        className
      )}
    >
      {status === "error" && (
        <span data-tooltip-content={statusTooltip}>
          <WarningOutlined className={styles.iconFailed} />
        </span>
      )}
      <div className={styles.content}>{children}</div>
      {status === "loading" && <LoadingOutlined data-status-tag="pending" />}
    </div>
  )
}
